import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e42c6c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "service-item-left" }
const _hoisted_3 = { class: "service-item-title" }
const _hoisted_4 = { class: "service-item-left-bottom" }
const _hoisted_5 = {
  key: 0,
  class: "service-item-time"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-arrow-right" }, null, -1))
const _hoisted_7 = { class: "service-item-left" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "service-item-title" }, "无人机第三者责任险(首年)", -1))
const _hoisted_9 = { class: "service-item-left-bottom" }
const _hoisted_10 = {
  key: 0,
  class: "service-item-time"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-arrow-right" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请求失败，点击重新加载", -1))
const _hoisted_13 = [
  _hoisted_12
]

import AppHeader from '@/components/Header.vue'
import { onBeforeMount, ref, Ref, withDefaults } from 'vue'
import { tagSatus, serviceTagSatusItem } from '@/types/three-liability-insurance'
import { getServiceList, getlastXcare } from '@/apis/three-liability-insurance'
import { useRouter, useRoute } from 'vue-router'
import { Toast } from 'vant'
import { AxiosError } from 'axios'
import { getStatusBgColor } from './common'
import { serviceItem2, lastXcareItem, serviceType } from '@/types/three-liability-insurance'
import dayjs from 'dayjs'
import appHost from '@/utils/app'


export default /*#__PURE__*/_defineComponent({
  __name: 'service',
  props: {
    displayMode: { default: 'Portrait' }
  },
  setup(__props: any) {

const props = __props as { displayMode: string };


let serviceLoading = ref(false)
let invalid = ref(false)
const xcareList: Ref<
  Array<
    lastXcareItem & {
      bgColor: string
      hasInsurance?: boolean
    }
  >
> = ref([])
const onLeftClick = function () {
  appHost.goAppBack()
}

const status: tagSatus<serviceTagSatusItem> = {
  0: {
    text: '无服务',
    background: 'rgba(0,0,0,0.22)',
  },
  1: {
    text: '保障中',
    background: 'rgba(57, 181, 74, 1)',
  },
  2: {
    text: '已到期',
    background: 'rgba(247,152,28,1)',
  },
}

let thirdPartyLiabilityInsranceData = ref<serviceItem2>({})
let route = useRoute()
let sn = route.query.sn as string
const router = useRouter()
function goToDetail(type: serviceType) {
  router.push({
    name: 'third-party-drone',
    query: {
      sn,
      type,
    },
  })
}
function toDetailHandle(item: lastXcareItem) {
  router.push({
    name: 'insurance-jijia-insurance-list',
    query: {
      eq_sn: sn,
    },
  })
}

async function getXcareListHandle() {
  try {
    let data = await getlastXcare({ serial_number: sn })
    if (!data || data.length === 0) {
      data = [
        {
          end_at: '',
          start_at: '',
          status: '',
          status_text: '无服务',
          type: 1,
          policy_no: '',
          service_type: 0, // 自定义为0  后续点击不会处理
          type_name: '无人机意外机损保险',
        },
      ]
    }
    xcareList.value = data
      .map((item) => ({
        ...item,
        type_name: '无人机意外机损保险',
        hasInsurance: item.status_text !== '无服务',
        end_at: item.end_at ? dayjs(item.end_at).format('YYYY.MM.DD') : '',
        bgColor: getStatusBgColor(item.status_text),
      }))
      .slice(0, 1)
  } catch (error) {
    return Promise.reject(error)
  }
}

async function thirdPartyLiabilityInsrance() {
  let data = await getServiceList({ sn })
  thirdPartyLiabilityInsranceData.value = data
  thirdPartyLiabilityInsranceData.value.policy_begin_date = dayjs(
    Number(data.policy_begin_date) * 1000
  ).format('YYYY.MM.DD')
  thirdPartyLiabilityInsranceData.value.policy_end_date = dayjs(
    Number(data.policy_end_date) * 1000
  ).format('YYYY.MM.DD')
}

const initData = async () => {
  Toast.loading({
    message: '加载中...',
    duration: 0,
  })
  try {
    await Promise.all([getXcareListHandle(), thirdPartyLiabilityInsrance()])
    Toast.clear()
    serviceLoading.value = true
  } catch (e) {
    invalid.value = true
    console.log('e', e)
    Toast.clear()
    if ((e as { status: number }).status === 4304) {
      Toast.fail('登录失效,请重新登录后再试')
    } else {
      Toast.fail((e as AxiosError)?.message || '网络连接错误，请稍后再试')
    }
  }
}

onBeforeMount(initData)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "服务",
      onLeftClick: onLeftClick,
      isReturnLeftEvent: ""
    }),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["service-list", props.displayMode === 'Landscape' ? 'landscape-width' : ''])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(xcareList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "service-item",
          key: index,
          onClick: ($event: any) => (toDetailHandle(item))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(item.type_name), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "service-item-tag",
                style: _normalizeStyle({ backgroundColor: item.bgColor })
              }, _toDisplayString(item.status_text), 5),
              (item.hasInsurance && item.status_text !== '待支付')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 有效期至 " + _toDisplayString(item.end_at ? item.end_at.split(' ')[0] : ''), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_6
        ], 8, _hoisted_1))
      }), 128)),
      _createElementVNode("div", {
        class: "service-item",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (goToDetail(_unref(serviceType).ThirdPartyLiabilityService)))
      }, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "service-item-tag",
              style: _normalizeStyle({ background: status[_unref(thirdPartyLiabilityInsranceData).status || 0]?.background })
            }, _toDisplayString(_unref(thirdPartyLiabilityInsranceData).status
                ? status[_unref(thirdPartyLiabilityInsranceData).status]?.text
                : status[0]?.text), 5),
            (_unref(thirdPartyLiabilityInsranceData).status === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 有效期至" + _toDisplayString(_unref(thirdPartyLiabilityInsranceData).policy_end_date), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_11
      ])
    ], 2), [
      [_vShow, _unref(serviceLoading)]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "invalid",
      onClick: initData
    }, _hoisted_13, 512), [
      [_vShow, _unref(invalid)]
    ])
  ], 64))
}
}

})